import * as React from 'react';
import cx from 'classnames';
import WikiModuleStore from './store';
import wrapStore from '@src/utils/wrap-store';
// import { px2rem2 } from '@src/utils/rem-util';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

const styles = require('./index.less');

// 通用浮窗组件（新增hover事件+滚动样式）
const TooltipFloat = ({ content, store }) => {
  // 当出现接口内容读取不到或者加载异常时，出现骨架屏，骨架屏即：设计稿中短文本词条样式。异常词条内容显示：【无法获取信息】
  const popupBaseStyle = {
    position: 'absolute',
    top: store.tooltipPosition?.top,
    left: store.tooltipPosition?.left,
    zIndex: 9999
  };
  // console.log('popupBaseStyle', popupBaseStyle);
  if (!content || !Object.keys(content).length) {
    return (
      <div
        className={cx(styles.tooltipFloat, styles.bg1)}
        style={popupBaseStyle}
        onMouseEnter={() => store.handleTooltipEnter()}
        onMouseLeave={() => store.handleTooltipLeave()}
      >
        {/* 浮窗内容容器（固定宽高+滚动） */}
        <div className={styles.tooltipContentWrapper}>
          <div className={styles.tooltiperr}>{pageLocalesData.commText}</div>
        </div>
      </div>
    );
  } else {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = content?.description;
    const plainText = tempElement.textContent || '';
    const trimmedText = plainText.trim();
    //  这里要判断下子元素  三种bg三种浮窗样式 有图片的统一渲染bg2  然后content字符超过了56个字符就用bg3 没图片和字符没超过的用bg1
    const hasImg = content?.entry_img?.[0]?.url && content?.entry_img?.[0]?.url !== '';
    const hasLongContent = trimmedText && trimmedText.length > 56;
    const bgClass = hasImg ? styles.bg2 : hasLongContent ? styles.bg3 : styles.bg1;
    return (
      <div
        className={cx(styles.tooltipFloat, bgClass)}
        style={popupBaseStyle}
        // 新增：浮窗的hover事件
        onMouseEnter={() => store.handleTooltipEnter()}
        onMouseLeave={() => store.handleTooltipLeave()}
      >
        {/* 浮窗内容容器（固定宽高+滚动） */}
        <div className={styles.tooltipContentWrapper}>
          {/* 浮窗标题 */}
          {content?.title && (
            <div className={styles.tooltipTitle}>
              <span className={styles.tooltipTitleText}>{content?.title}</span>
            </div>
          )}
          {/* 浮窗文案（超出滚动） */}
          {content?.description && <div className={styles.tooltipScrollContent} dangerouslySetInnerHTML={{ __html: content?.description }} />}
        </div>
        {/* 浮窗图片 */}
        {content?.entry_img?.[0]?.url && (
          <div className={styles.tooltip_img_wrap}>
            <img src={content?.entry_img?.[0]?.url} alt={content?.name} className={styles.tooltipImg} onError={e => (e.target.style.display = 'none')} />
          </div>
        )}
      </div>
    );
  }
};

/**
 * 解析富文本（含omni类span）为React元素
 * @param {string} rawText - 接口返回的富文本字符串
 * @param {Object} store - WikiModuleStore实例
 * @returns {Array<React.ReactNode>} 解析后的React元素数组
 */
// 定义HTML空元素（自闭合，无子女节点）列表
const VOID_ELEMENTS = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);

const parseTextWithTags = (rawText, store) => {
  if (!rawText || typeof rawText !== 'string') return [];

  const parser = new DOMParser();
  const doc = parser.parseFromString(rawText, 'text/html');
  const rootNodes = Array.from(doc.body.childNodes);

  // 【关键：单次解析只初始化一次计数器，所有嵌套节点共享】
  let termIndexCounter = 0;

  // 递归处理节点的函数（闭包共享termIndexCounter）
  const processNode = (node, nodeIndex) => {
    // 生成React元素的key（原有逻辑）
    const generateUniqueKey = prefix => {
      if (node.nodeType === Node.TEXT_NODE) {
        return `${prefix}_text_${nodeIndex}_${node.textContent.slice(0, 10)}`.replace(/\s+/g, '_');
      }
      const attrStr = Array.from(node.attributes || [])
        .map(attr => `${attr.name}=${attr.value}`)
        .join('_');
      return `${prefix}_${node.tagName?.toLowerCase() || 'node'}_${nodeIndex}_${attrStr}`.replace(/\s+/g, '_');
    };
    const baseKey = generateUniqueKey('parse');

    // 1. 处理文本节点
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      return text ? <React.Fragment key={baseKey}>{text}</React.Fragment> : null;
    }

    // 2. 处理元素节点
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tagName = node.tagName.toLowerCase();

      // 处理词条span（共享计数器，持续自增）
      if (tagName === 'span' && node.classList.contains('omni_rich_term')) {
        const contentId = node.getAttribute('data-omni-content-ids') || '';
        const displayName = node.textContent || '未知词条';

        if (!contentId) {
          return <React.Fragment key={baseKey}>{displayName}</React.Fragment>;
        }

        const matchKey = contentId;
        // 【计数器在单次解析中持续自增，不管嵌套多少层】
        const uniqueIndex = termIndexCounter++;
        const activeKey = `tag_${matchKey}_${uniqueIndex}`;

        const originalSpanAttrs = {};
        Array.from(node.attributes).forEach(attr => {
          if (attr.name.startsWith('data-')) {
            originalSpanAttrs[attr.name] = attr.value;
          }
        });
        // 挂载唯一index到data属性
        originalSpanAttrs['uniqueIndex'] = uniqueIndex;

        return (
          <div
            key={activeKey}
            className={cx(styles.desc_active, styles.tooltipContainer)}
            {...originalSpanAttrs}
            onMouseEnter={e => {
              store.handleTargetEnter('tag', matchKey, contentId, 'desc', e);
            }}
            onMouseLeave={() => store.handleTargetLeave()}
          >
            {displayName}
            {store.tooltipVisible && store.activeKey === activeKey && <TooltipFloat content={store.tooltipContent} store={store} />}
          </div>
        );
      }

      // 处理非词条元素节点（递归处理子节点，共享同一个计数器）
      const isVoidElement = VOID_ELEMENTS.has(tagName);
      let children = [];
      if (!isVoidElement) {
        children = Array.from(node.childNodes)
          .map((child, childIndex) => processNode(child, childIndex)) // 递归调用processNode，共享计数器
          .filter(Boolean);
      }

      // 过滤class/style属性
      const attrs = {};
      Array.from(node.attributes).forEach(attr => {
        if (attr.name !== 'class' && attr.name !== 'style') {
          attrs[attr.name] = attr.value;
        }
      });
      attrs.key = baseKey;

      if (isVoidElement) {
        return React.createElement(tagName, attrs);
      }

      return React.createElement(tagName, attrs, children);
    }

    return null;
  };

  // 处理根节点，返回结果
  return rootNodes.map((node, nodeIndex) => processNode(node, nodeIndex)).filter(Boolean);
};

const WikiModule = ({ store, data, dictData, characterDataMap, factionDataMap }) => {
  store.use();
  if (!data || !dictData?.entries) return null;
  // 赋值
  store.tooltipDataMap = dictData.entries;
  store.characterDataMap = characterDataMap;
  store.factionDataMap = factionDataMap;

  //滚动容器（.scroll）的 ref
  const scrollContainerRef = React.useRef(null);

  React.useEffect(
    () => {
      // 将滚动容器 ref 传递给 store
      if (scrollContainerRef.current) {
        store.setScrollContainer(scrollContainerRef.current);
      }
    },
    [store]
  );

  return (
    <div className={styles.wikiModuleRoot}>
      {/* 标题区域 */}
      <div className={cx(styles.wikiTitleBox)}>
        <div className={styles.head_icon} />
        <div className={styles.title_num}> {data?.data}</div>
        <div className={styles.title_text}>
          <div className={styles.title}>{data?.title}</div>
          {/* <div className={styles.title_lang}>{data?.subtitle}</div> */}
        </div>
      </div>
      <div className={cx(styles.scroll)} ref={scrollContainerRef}>
        <div className={cx(styles.scroll_content)}>
          {/* 描述文本 */}
          <div className={styles.desc} id="desc">
            {parseTextWithTags(data.description, store)}
          </div>
          {/* 关联势力 */}
          {store.factionDataMap?.length > 0 && (
            <div className={styles.force_box} id="force_box">
              <div className={styles.force_title}>
                <span>{pageLocalesData.modalText1}</span>
              </div>
              <div className={styles.force_list}>
                {store.factionDataMap?.map((item, index) => {
                  const activeKey = `force_${index}`;
                  return (
                    <div
                      key={activeKey}
                      className={cx(styles.force_item)}
                      onMouseEnter={e => store.handleTargetEnter('force', index, item, 'force_box', e)}
                      onMouseLeave={() => store.handleTargetLeave()}
                    >
                      {item?.title}
                      {store.tooltipVisible && store.activeKey === activeKey && <TooltipFloat content={store.tooltipContent} store={store} />}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* 关联人物 */}
          {store.characterDataMap?.length > 0 && (
            <div className={styles.character_box} id="character_box">
              <div className={styles.character_title}>
                <span>{pageLocalesData.modalText2}</span>
              </div>
              <div className={styles.character_list}>
                {store.characterDataMap?.map((item, index) => {
                  const activeKey = `character_${index}`;
                  return (
                    <div
                      key={activeKey}
                      className={cx(styles.character_item)}
                      onMouseEnter={e => store.handleTargetEnter('character', index, item, 'character_box', e)}
                      onMouseLeave={() => store.handleTargetLeave()}
                    >
                      <img className={styles.characterImg} src={item?.entry_img?.[0]?.url} alt={item.tile} />
                      {store.tooltipVisible && store.activeKey === activeKey && <TooltipFloat content={store.tooltipContent} store={store} />}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(WikiModule, WikiModuleStore);
